<template>
  <div class="pretraining-video">
    <h3 class="pretraining-video-heading sm:text-center">
      {{ `${$t('preTraining.lesson.heading', { number: video.order - 1 })} ${video.title}` }}
    </h3>
    <div class="pretraining-video-main">
      <Video
        :thumbnail="video.thumbnail"
        :video="video.code"
        :completed="completed"
        :currentTime="currentTime"
        :isLast="isLast"
        @pauseVideo="onPauseVideo"
        @endVideo="onEndVideo"
        @resetVideo="onResetVideo"
      />
      <div class="mt-6 md:mt-0">
        <p class="pretraining-video-summary" v-html="video.summary"></p>
        <p
          v-if="isVisionProduct()"
          class="pretraining-video-summary text-ricoma-red-100 border border-ricoma-red-100 p-3"
          v-html="$t('preTraining.vision.warning.content')"
        />
        <div v-if="!!resources.length" class="pretraining-video-resources">
          <h4 class="pretraining-video-resources-heading">
            {{ $t('preTraining.lesson.resources') }}
          </h4>
          <ul>
            <li
              v-for="({ title, link, file_path }, index) in resources"
              :key="`resource-${index}`"
              class="pretraining-video-resources-resource"
            >
              <a :href="link ? link : file_path" target="_blank" download>{{ title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="!!checklists.length" class="px-12 py-8 bg-white rounded shadow-md">
      <h4 class="pretraining-video-resources-heading">{{ $t('preTraining.checklist.title') }}</h4>
      <div
        v-for="(checklist, index) in checklists"
        :key="`checklist-${index}`"
        class="flex items-center mb-2"
      >
        <div class="flex order-2 ml-4 truncate">
          {{ checklist.text }}
          <div v-if="checklist.link_text" class="flex">
            <span
              @click="openVideo(checklist.thumbnail_link, checklist.link_video)"
              class="flex items-center text-xs uppercase cursor-pointer text-ricoma-blue-100 hover:text-ricoma-blue-200"
            >
              <VSvgIcon name="play" class="w-5 ml-2 mr-1" />
              {{ checklist.link_text }}
            </span>
          </div>
        </div>
        <div class="checkbox">
          <input
            class="checkbox-input"
            type="checkbox"
            :id="`checkbox-${index}`"
            :checked="checkedListItems.find(c => c === checklist.id)"
            :value="checklist.id"
            @change="checkValue($event)"
          />
          <label class="checkbox-label" :for="`checkbox-${index}`"></label>
        </div>
      </div>
    </div>
    <div
      v-if="isLast && customerGroup && customerGroup.enable_training === 0"
      class="bg-white rounded shadow p-12"
    >
      <VSvgIcon name="information" width="40" height="40" class="text-blue-400 mx-auto mb-6" />
      <p v-html="$t('preTraining.thank_you.content_warning.p-1')" class="mb-6 text-center" />
      <p v-html="$t('preTraining.thank_you.content_warning.p-2')" class="text-center" />
    </div>
    <button
      class="py-5 mx-auto my-10 rounded-full button"
      :disabled="
        !completed ||
        !isCheckListCheck ||
        (isLast && customerGroup && customerGroup.enable_training === 0)
      "
      v-show="!isLast || (isLast && hasTraining)"
      @click="$emit('fetchQuiz', video.id, $language.code)"
    >
      {{ isLast ? $t('preTraining.scheduleBtn') : $t('preTraining.takeNoQuizBtn') }}
    </button>
    <!-- How it works video -->
    <Modal :show="showModal" @close="showModal = false" width="95%" maxWidth="900px" theme="dark">
      <Video :thumbnail="actual_thumbnail" :video="actual_video" />
    </Modal>
  </div>
</template>

<script>
import Video from './Video';
import { safeNullDataset } from '@/utils';
import VSvgIcon from '@/components/base/VSvgIcon';
import Modal from '@/components/shared/modal/Modal';
import { isVision } from '@/utils';

export default {
  name: 'PretrainingLessonVideo',
  components: { Video, VSvgIcon, Modal },
  props: {
    title: String,
    checklists: Array,
    product: Object,
    customerGroup: Object,
    checkedListItems: Array,
    video: Object,
    onPauseVideo: Function,
    onEndVideo: Function,
    onResetVideo: Function,
    isLast: Boolean,
    hasTraining: Boolean,
  },
  data() {
    return {
      actual_video: '',
      actual_thumbnail: '',
      showModal: false,
    };
  },
  computed: {
    resources() {
      return safeNullDataset(this.video)(['resources', 'data']);
    },
    currentTime() {
      return this.video && this.video.progress ? this.video.progress.time : '0';
    },
    completed() {
      return this.video && this.video.progress ? !!this.video.progress.complete : false;
    },
    isCheckListCheck() {
      return this.checklists.length > 0
        ? this.checkedListItems.length >= this.checklists.length
          ? true
          : false
        : true;
    },
  },
  methods: {
    openVideo(thumbnail, video) {
      this.showModal = true;
      this.actual_thumbnail = thumbnail;
      this.actual_video = video;
    },
    checkValue(event) {
      this.$emit('checkValueList', event);
    },
    isVisionProduct() {
      return isVision(this.product.display_name);
    },
  },
  async mounted() {},
};
</script>
